import { EXERCISE_KEY } from '../../../../exercise'
import { WORKOUT_EXERCISE_KEY } from '../../constants'
import getByIdExerciseSelector from '../../../../exercise/redux/selectors/get-by-id'
import { MODEL_KEY } from '../../../../../modules/model/constants'
import createPointerReduxUtil from '../../../../redux/utils/create-pointer'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import updateDataReduxUtil from '../../../../redux/utils/update-data'
import setUtil from '../../../../../utils/set'

function afterCreateWorkoutExerciseHook (instance, state) {
  if (getValueReduxUtil(instance, WORKOUT_EXERCISE_KEY.EXERCISE)) {
    return state
  }
  const exerciseId = getValueReduxUtil(instance, WORKOUT_EXERCISE_KEY.EXERCISE_ID)
  const exercise = getByIdExerciseSelector(exerciseId)(state)

  const newInstance = updateDataReduxUtil(instance, {
    [WORKOUT_EXERCISE_KEY.EXERCISE]: createPointerReduxUtil(
      exercise || { data: { [MODEL_KEY.ID]: exerciseId } },
      [EXERCISE_KEY.NAME]
    )
  })
  return setUtil(state, getPathReduxUtil(newInstance), newInstance)
}

export default afterCreateWorkoutExerciseHook
